import {fetch} from "utils/dataAccess";

export default async function ship(shipment, toShipObject = {})  {
    const response = await fetch(`/shipments/${shipment.id}/ship`, {
        method: "POST",
        body: JSON.stringify(toShipObject),
    });

    return await response.json();
}
